// Free of browser imports, so `bun test` can load it.

/** Login H2J (#700): the OIDC provider id registered in the API (`genericOAuth`). */
export const H2J_PROVIDER_ID = "h2j";

/**
 * Whether the profile's Password section shows the Login H2J notice instead of the
 * form. Better Auth keeps the local password on the `credential` account: whoever
 * came in through Login H2J (invitation or provisioning) has none, so there is
 * nothing to change here (#720). After the switch a linked account changes it there
 * too (#719) and an unlinked one keeps the form. This goes by the link, not by the
 * emergency list (`AUTH_LOCAL_LOGIN_EMAILS`), which only the API knows: an emergency
 * account that Login H2J linked gets the notice. Accounts not loaded keep the form.
 */
export function passwordChangedOnH2j(
  accounts: readonly { providerId: string }[] | undefined,
  ssoOnly: boolean,
): boolean {
  if (!accounts) return false;
  const localPassword = accounts.some((account) => account.providerId === "credential");
  const linked = accounts.some((account) => account.providerId === H2J_PROVIDER_ID);
  return !localPassword || (ssoOnly && linked);
}
